import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { Stack } from '@mui/material'
import { EditRounded, GroupAddRounded } from '@mui/icons-material'

import { useStores } from '@trivie/core'
import { Header } from '@trivie/ui-web/components/header'
import { NavigationTabs } from '@trivie/ui-web/components/navigation-tabs'
import { Text } from '@trivie/ui-web/components/text'

import { SubscriptionChip } from './subscription-chip'
import { SubscriptionCreateDialog } from './create-subscription/subscription-create'
import { GiftSubscriptionDialog } from './gift-subscription/gift-subscription-dialog'
import { subscriptionProductDetailTabs } from './tabs'

export const SubscriptionProductDetailScreen: React.FunctionComponent = observer(() => {
  const { id } = useParams<{ id: string; tab: string }>()
  const { subscriptionStore, manageUserStore } = useStores()

  const { permissions } = manageUserStore

  const [showEdit, setShowEdit] = useState(false)
  const [showGift, setShowGift] = useState(false)

  const product = subscriptionStore.selectedProduct
  const isActive = Boolean(product?.is_active)
  const durationText = product?.durationText ?? 'Open'

  useEffect(() => {
    subscriptionStore.setSelectedProduct(null)
    subscriptionStore.getProduct(Number(id))
  }, [id])

  const primaryAction = {
    startIcon: <EditRounded />,
    onClick: () => setShowEdit(true),
    disabled: !permissions?.permissions.some((p) => p.code === 'can_edit_product'),
    text: 'Edit Subscription',
  }

  const secondaryAction = {
    startIcon: <GroupAddRounded />,
    onClick: () => setShowGift(true),
    text: 'Add Subscribers',
    disabled: !isActive || !permissions?.permissions.some((p) => p.code === 'can_edit_product'),
  }

  return (
    <>
      <Header
        title={product?.title}
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
      />
      {product && (
        <Stack direction="row" alignItems="center" gap={1} sx={{ py: 1 }}>
          <Text
            variant="body1"
            text={`SKU: ${product.sku} · ${durationText}`}
            sx={{ color: 'text.secondary' }}
          />
          <SubscriptionChip status={isActive ? 'active' : 'inactive'} />
        </Stack>
      )}
      <NavigationTabs tabList={subscriptionProductDetailTabs} id={Number(id)} />
      <SubscriptionCreateDialog
        open={showEdit}
        requestClose={() => setShowEdit(false)}
        editingProduct={product}
      />
      <GiftSubscriptionDialog
        productNames={[subscriptionStore.products[id]?.title]}
        open={showGift}
        requestClose={() => {
          setShowGift(false)
          subscriptionStore.getPurchases(Number(id))
          subscriptionStore.getProduct(Number(id))
        }}
        defaultDuration={product?.duration_days}
        productIds={[Number(id)]}
      />
    </>
  )
})
